import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedManga from './components/FeaturedManga';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'h漫画',
  url: 'https://hmanga.com',
  description: 'h漫画是面向成熟读者的在线漫画阅读平台，汇聚海量精选h漫画资源，涵盖多种风格与题材，支持高清流畅阅读体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hmanga.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedManga />
        <LatestUpdates />
        <PopularRanking />
      </main>
      <Footer />
    </>
  );
}